import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

class Breadcrumb extends Component {
  static propTypes = {
    steps: PropTypes.array.isRequired,
  }

  state = {
    steps: [],
  }

  componentDidMount() {
    this.setState({ steps: this.props.steps })
  }

  renderSteps = () => {
    const { steps } = this.state

    return steps.map((step, index) => (
      <li
        className={`breadcrumb-item ${step.callback ? 'pointer' : null}`}
        key={index}
        onClick={step.callback}
      >
        {step.link && (
          <Link
            to={step.link}
            title={step.title}
            className={`color-text ${step.className || ''}`}
          >
            {step.title && <span className='name'>{step.title}</span>}
          </Link>
        )}

        {!step.link && step.title && (
          <span className='name'>
            {step.strong ? <strong>{step.title}</strong> : step.title}
          </span>
        )}
      </li>
    ))
  }

  render() {
    const { steps } = this.state

    return (
      <>
        {!!steps.length && (
          <div className='breadcrumb margin-left-double margin-right-double'>
            <ul className='breadcrumb-list'>{steps && this.renderSteps()}</ul>
            <hr />
          </div>
        )}
      </>
    )
  }
}

export default Breadcrumb
